export default "__VITE_ASSET__DFwnDJ$F__"